// Create a new custom element for product links with images for transitions to PDP
class ProductCardLink extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#handleClick);

    // Desktop hover only
    if (window.matchMedia('(hover: hover)').matches) {
      this.addEventListener('mouseenter', this.#handleMouseEnter);
      this.addEventListener('mouseleave', this.#handleMouseLeave);
    }
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
    this.removeEventListener('mouseenter', this.#handleMouseEnter);
    this.removeEventListener('mouseleave', this.#handleMouseLeave);
  }

  get productTransitionEnabled() {
    return this.getAttribute('data-product-transition') === 'true';
  }

  get featuredMediaUrl() {
    return this.getAttribute('data-featured-media-url');
  }

  /**
   * CLICK → PDP transition
   */
  #handleClick = (event) => {
    if (event.defaultPrevented) return;

    if (event.target instanceof Element) {
      const interactiveElement = event.target.closest(
        'button, input, label, select, [tabindex="1"]'
      );
      if (interactiveElement) return;
    }

    const gallery = this.querySelector('[data-view-transition-to-main-product]');
    if (!this.productTransitionEnabled || !(gallery instanceof HTMLElement)) return;

    const activeImage = gallery.querySelector(
  '.resource-card__image:not(.resource-card__image--secondary)'
);
    if (activeImage instanceof HTMLImageElement) {
      this.#setImageSrcset(activeImage);
    }

    gallery.setAttribute('data-view-transition-type', 'product-image-transition');
    gallery.setAttribute('data-view-transition-triggered', 'true');
  };

  /**
   * HOVER IN → swap image
   */
 #handleMouseEnter = () => {
  const primaryImage = this.querySelector(
    '.resource-card__image:not(.resource-card__image--secondary)'
  );
  const hoverImage = this.querySelector(
    '.resource-card__image--secondary'
  );

  if (!primaryImage || !hoverImage) return;

  if (!primaryImage.dataset.originalSrc) {
    primaryImage.dataset.originalSrc =
      primaryImage.currentSrc || primaryImage.src;
  }

  primaryImage.src = hoverImage.currentSrc || hoverImage.src;
};

#handleMouseLeave = () => {
  const primaryImage = this.querySelector(
    '.resource-card__image:not(.resource-card__image--secondary)'
  );

  if (!primaryImage || !primaryImage.dataset.originalSrc) return;

  primaryImage.src = primaryImage.dataset.originalSrc;
};

  /**
   * Sets the srcset for the image (click transition)
   */
  #setImageSrcset(image) {
    if (!this.featuredMediaUrl) return;

    const currentImageUrl = new URL(image.currentSrc);
    const currentImageRawUrl =
      currentImageUrl.host + currentImageUrl.pathname;

    if (!this.featuredMediaUrl.includes(currentImageRawUrl)) {
      const imageFade = image.animate([{ opacity: 0.8 }, { opacity: 1 }], {
        duration: 125,
        easing: 'ease-in-out',
      });

      imageFade.onfinish = () => {
        image.srcset = this.featuredMediaUrl ?? '';
      };
    }
  }
}

if (!customElements.get('product-card-link')) {
  customElements.define('product-card-link', ProductCardLink);
}